import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class DateUtils {


  /**
   * Formats an ISO date string to a specified format with AM/PM.
   * @param isoDate - The ISO string to format (e.g., 2024-12-18T18:30:00.000+00:00).
   * @param format - The desired Angular DatePipe format (default: 'dd-MM-yyyy, hh:mm a').
   * @param locale - The locale to use for formatting (default: 'en-US').
   * @returns The formatted date string or an empty string if input is invalid.
   */
  static formatDate(isoDate: string, format: string = 'dd-MM-yyyy, hh:mm a'): string {
    if (!isoDate) {
      console.warn('Date string is invalid.');
      return '';
    }

    try {
      const locale = navigator.language || 'en-US';
      return formatDate(isoDate, format, locale);
    } catch (error) {
      console.error('Error formatting date:', error);
      return '';
    }
  }

  static toLocalDateTimeString(date: Date): string {
    const p = (n: number) => String(n).padStart(2, "0");
    const off = -date.getTimezoneOffset();
    const sign = off >= 0 ? "+" : "-";
    const a = Math.abs(off);
    return `${date.getFullYear()}-${p(date.getMonth() + 1)}-${p(date.getDate())}T${p(date.getHours())}:${p(date.getMinutes())}:${p(date.getSeconds())}${sign}${p(Math.floor(a / 60))}:${p(a % 60)}`;
  }

  static addDays(date: Date, days: number): string {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return DateUtils.toLocalDateTimeString(result);
  }

  static getUTCDateTime(dateTime: Date): string {
    console.log("Date: ", dateTime.toISOString());
    const utcDate = new Date(dateTime.getTime() - dateTime.getTimezoneOffset() * 60000);
    console.log("UTC Date: ", utcDate.toISOString());
    return utcDate.toISOString()
  }
}
